<template>
  <div class="widget-rb__container">
    <div
      v-for="(option, index) in options"
      :key="index"
      class="widget-rb__rb-button"
      :class="[comparator(option, selected) ? 'active' : '']"
      @click="$emit('click', option)"
    >
      <slot v-bind:option="option"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: Array,
    selected: Object,
    comparator: {
      type: Function,
      default: (option, selected) => option === selected,
    },
  },
}
</script>

<style lang="scss">
.widget-rb {
  &__container {
    display: flex;
    flex-direction: row;
    gap: 4px;
    line-height: 20px;
    letter-spacing: 0.5px;
    height: 1.35em;
  }
  &__rb-button {
    border: 1px solid #eaeaf5;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 12px;
    line-height: 16px;
    padding: 0px 8px;
    text-align: center;
    cursor: pointer;
    &.active {
      background: #9d9dbc;
      border-color: #9d9dbc;
      border-radius: 4px;
      color: #ffffff;
    }
  }
}
</style>
